import {Settings} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'settings',
    children: [
      {
        path: '',
        loader: protectedLoader('SETTINGS', 'VIEW_SETTINGS'),
        async lazy() {
          const {SettingsPage} = await import('./pages/SettingsPage');
          return {element: <SettingsPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/settings',
    text: i18n.t('Settings'),
    icon: <Settings />,
    permission: 'VIEW_SETTINGS',
    entitlement: 'SETTINGS',
  },
] as MenuItemElement[];
